<template>
  <div>
    <el-badge :is-dot="showMessageDot" :style="{ 'margin-top': '10px' }">
      <el-icon size="20" color="#409EFC"
        ><bell-filled @click="openMessageDialog"
      /></el-icon>
    </el-badge>
    <el-dialog
      v-model="showMessageCenterDialog"
      title="消息中心"
      :style="{ 'text-align': 'left' }"
      width="1200"
    >
      <el-form :model="queryParams" ref="queryFormRef" label-width="100px">
        <el-row>
          <el-col :span="6">
            <el-form-item label="标题：" prop="title">
              <el-input
                type="text"
                v-model="queryParams.title"
                :maxlength="128"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="类型：" prop="type">
              <el-select v-model="queryParams.type" clearable>
                <el-option
                  v-for="item in messageTypeOptions"
                  :key="item.dictValue"
                  :value="item.dictValue"
                  :label="item.dictLabel"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="来源：" prop="source">
              <el-select v-model="queryParams.source" clearable>
                <el-option
                  v-for="item in messageSourceOptions"
                  :key="item.value"
                  :value="item.value"
                  :label="item.desc"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="状态：" prop="readStatus">
              <el-select v-model="queryParams.readStatus" clearable>
                <el-option
                  v-for="item in messageReadStatusOptions"
                  :key="item.value"
                  :value="item.value"
                  :label="item.desc"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="时间：" prop="timeRange">
              <el-date-picker
                type="daterange"
                range-separator="-"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="YYYY-MM-DD"
                v-model="queryParams.timeRange"
                placeholder="请选择"
                @change="handleTimeRangeChange"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item>
              <el-button type="primary" icon="Search" @click="queryAllMessage">
                查询
              </el-button>
              <el-button @click="resetSearch"> 重置 </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <el-table
        :data="messageList"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="title" label="消息标题" width="180">
        </el-table-column>
        <el-table-column prop="type" label="消息类型" width="120">
          <template #default="scope">
            {{
              messageTypeOptions.find(
                (item) => item.dictValue == scope.row.type
              )?.dictLabel || "-"
            }}
          </template>
        </el-table-column>
        <el-table-column prop="source.desc" label="消息来源"> </el-table-column>
        <el-table-column prop="refKey" label="关联标识" width="180">
        </el-table-column>
        <el-table-column prop="time" label="消息时间" width="160">
        </el-table-column>
        <el-table-column prop="readStatus.desc" label="是否读取">
        </el-table-column>
        <el-table-column prop="remark" label="详细描述" width="200">
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="100">
          <template #default="scope">
            <el-button
              @click="handleDetailMessage(scope.row)"
              type="text"
              size="small"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="table-pagination">
        <el-pagination
          v-model:current-page="queryParams.page"
          v-model:page-size="queryParams.limit"
          :page-sizes="[5]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @current-change="queryAllMessage"
        />
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button
            @click="handleBatchReadMessage"
            :disabled="selectedMessageList.length == 0"
            >批量已读</el-button
          >
          <el-button type="primary" @click="handleAllReadMessage">
            全部已读
          </el-button>
          <el-button @click="showMessageCenterDialog = false">关闭</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import {
  defineComponent,
  reactive,
  toRefs,
  getCurrentInstance,
  onMounted,
  onUnmounted,
} from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { ElNotification } from "element-plus";

export default defineComponent({
  setup() {
    const { proxy } = getCurrentInstance();
    const router = useRouter();
    const store = useStore();
    const state = reactive({
      // 显示消息中心红点
      showMessageDot: true,
      autoRefreshMessageTask: null,
      messageNotifactionPromise: Promise.resolve(),
      // 打开消息中心
      showMessageCenterDialog: false,
      // 消息类型
      messageTypeOptions: [],
      // 消息来源
      messageSourceOptions: [
        {
          value: 1,
          desc: "厂站系统",
        },
        {
          value: 2,
          desc: "供水管网",
        },
        {
          value: 3,
          desc: "营销系统",
        },
        {
          value: 4,
          desc: "预算系统",
        },
        {
          value: 5,
          desc: "工程系统",
        },
        {
          value: 99,
          desc: "其他",
        },
      ],
      // 消息状态
      messageReadStatusOptions: [
        {
          value: 1,
          desc: "未读",
        },
        {
          value: 2,
          desc: "已读",
        },
      ],
      // 查询参数
      queryParams: {
        title: "",
        type: "",
        source: null,
        readStatus: null,
        timeRange: [],
        startTime: null,
        endTime: null,
        page: 1,
        limit: 5,
      },
      // 记录数量
      total: 0,
      // 消息列表
      messageList: [],
      selectedMessageList: [],
    });
    onMounted(() => {
      queryMessageType();
      queryUnReadMessage();
      startAutoRefreshMessageTask();
    });
    onUnmounted(() => {
      stopAutoRefreshMessageTask();
    });
    // 开启自动刷新消息任务
    const startAutoRefreshMessageTask = () => {
      state.autoRefreshMessageTask = setInterval(() => {
        queryUnReadMessage();
      }, 120000);
    };
    const stopAutoRefreshMessageTask = () => {
      if (state.autoRefreshMessageTask) {
        clearInterval(state.autoRefreshMessageTask);
      }
    };
    // 打开消息中心
    const openMessageDialog = () => {
      state.showMessageCenterDialog = true;
      queryAllMessage();
    };
    //获取未读消息列表
    const queryMessageType = () => {
      proxy.$api
        .postDictDataList({
          dictType: "work_message_type",
        })
        .then((res) => {
          state.messageTypeOptions = res.data || [];
        });
    };
    //获取未读消息列表
    const queryUnReadMessage = () => {
      proxy.$api
        .pageWorkMessageWithCurrentUser({
          ...state.queryParams,
          readStatus: 1,
          limit: 3,
        })
        .then((res) => {
          const msgQty = res.data?.total || 0;
          state.showMessageDot = msgQty > 0;
          if (msgQty > 0) {
            res.data.records.forEach((msg) => {
              state.messageNotifactionPromise =
                state.messageNotifactionPromise.then(() => {
                  openMessageNotification(msg);
                });
            });
          }
        });
    };
    const openMessageNotification = (message) => {
      const notification = ElNotification({
        dangerouslyUseHTMLString: true,
        title:
          state.messageTypeOptions.find(
            (item) => item.dictValue == message.type
          )?.dictLabel || "-",
        message: `消息标题: ${message.title} <br />
                  消息来源: ${message.source.desc} <br />
                  消息时间: ${message.time} `,
        type: "info",
        duration: 10000,
        onClick: () => {
          handleDetailMessage(message);
          notification.close();
        },
      });
    };
    const handleTimeRangeChange = () => {
      if (state.queryParams.timeRange.length > 0) {
        state.queryParams.startTime =
          state.queryParams.timeRange[0] + " 00:00:00";
        state.queryParams.endTime =
          state.queryParams.timeRange[1] + " 23:59:59";
      }
    };
    const resetQueryParams = () => {
      return {
        title: "",
        type: "",
        source: null,
        readStatus: null,
        timeRange: [],
        startTime: null,
        endTime: null,
        page: 1,
        limit: 5,
      };
    };
    const resetSearch = () => {
      state.queryParams = resetQueryParams();
      queryAllMessage();
    };
    //获取消息列表
    const queryAllMessage = () => {
      proxy.$api
        .pageWorkMessageWithCurrentUser(state.queryParams)
        .then((res) => {
          state.messageList = res.data?.records || [];
          state.total = res.data?.total || 0;
        });
    };
    //获取消息详情
    const handleDetailMessage = (message) => {
      proxy.$api
        .getMessageTemplateBySourceAndType(message.source.value, message.type)
        .then((res) => {
          const template = res.data;
          if (template.id) {
            state.showMessageCenterDialog = false;
            jumpSystem(template, message);
          }
        });
      proxy.$api.batchReadWorkMessage([message.id]).then((res) => {
        queryAllMessage();
      });
    };
    const jumpSystem = (template, message) => {
      store.commit("permission/SET_SUB_SYSTEM_ID", template.systemId);
      sessionStorage.setItem("subSystemId", template.systemId);
      router.push({
        path: template.jumpMenuPath,
        query: { refKey: message.refKey, ts: Date.now() },
      });
    };
    const handleSelectionChange = (val) => {
      state.selectedMessageList = val;
    };
    // 批量已读
    const handleBatchReadMessage = () => {
      if (state.selectedMessageList.length == 0) {
        return;
      }
      const selectedMessageIds = state.selectedMessageList.map(
        (item) => item.id
      );
      proxy.$api.batchReadWorkMessage(selectedMessageIds).then((res) => {
        if (res.code == "2000") {
          state.selectedMessageList = [];
          queryAllMessage();
        }
      });
    };
    //全部已读
    const handleAllReadMessage = () => {
      proxy.$api.allReadWorkMessage().then((res) => {
        if (res.code == "2000") {
          queryAllMessage();
        }
      });
    };
    return {
      ...toRefs(state),
      openMessageDialog,
      resetQueryParams,
      handleTimeRangeChange,
      resetSearch,
      queryAllMessage,
      handleDetailMessage,
      handleSelectionChange,
      handleBatchReadMessage,
      handleAllReadMessage,
    };
  },
});
</script>

<style lang="less" scoped>
.dialog-header {
  text-align: left;
  margin-top: 16px;
  width: 100%;
  display: flex;
  justify-content: flex-start;
}

.table-pagination {
  text-align: right;
  margin-top: 16px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
</style>
